import { render, staticRenderFns } from "./GetInvoiceToEmail.vue?vue&type=template&id=cfdf5f02"
import script from "./GetInvoiceToEmail.vue?vue&type=script&lang=js"
export * from "./GetInvoiceToEmail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports